import { useResponsive } from 'contexts/useResponsive';

const useCloseSidebar = () => {
    const { isMobile, setIsSidebarCollapsed } = useResponsive();
    return () => {
        if (!isMobile) return;
        setIsSidebarCollapsed(true);
    };
};

export { useCloseSidebar };
